import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { InvoiceHistoryuploadedResponse } from 'src/app/_Models/invoice/invoice-summary.model';
import { InvoiceSummaryService } from 'src/app/_Services/invoice/invoice-summary.service';

@Component({
    selector: 'app-view-invoice-history-popup',
    templateUrl: './view-invoice-history-popup.component.html',
    styleUrls: ['./view-invoice-history-popup.component.scss']
})
export class ViewInvoiceHistoryPopupComponent implements OnInit {

    @Input() invoiceId: number = 0;

    historyList: Array<InvoiceHistoryuploadedResponse> = [];
    isLoading: boolean = false;
    @Input() quotationId: number;
    uploadHistroyloading = false;
    componentDestroyed$ = new Subject<boolean>();
  bookingNo: Array<string> = [];


    /** -----------------------
     *   FINAL FIXED UI MAPPER
     * ----------------------*/
    historyUIMap: any = {
        approved: {
            match: (item: any) => item.statusId === 3,
            icon: 'assets/images/new-set/filled-green-pass.svg',
            title: 'Approved',
            isBadge: false,
            titleClass: 'green_text'
        },
        rejected: {
            match: (item: any) => item.statusId === 2,
            icon: 'assets/images/new-set/fail-circle.svg',
            title: 'Rejected',
            isBadge: false,
            titleClass: 'red_text'
        },
        uploaded: {
            match: (item: any) => item.isQuotationReuploaded == true,   // FIXED
            icon: 'assets/images/filled-quotation.svg',
            title: 'Invoice Re-uploaded',
            isBadge: true,
            titleClass: ''
        },
        reuploaded: {
            match: (item: any) => item.isQuotationReuploaded == false,  // FIXED
            icon: 'assets/images/filled-quotation.svg',
            title: 'Invoice Uploaded',
            isBadge: true,
            titleClass: ''
        }
    };

    constructor(
        public invoiceService: InvoiceSummaryService,
        public activeModal: NgbActiveModal
    ) { 
              this.bookingNo = [];

    }

    ngOnInit(): void {
        this.uploadHistroyloading = true;

        this.invoiceService.getInvoiceHistory(this.invoiceId)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (response) => {
                    this.historyList = response;
                    this.uploadHistroyloading = false;
                     this.bookingNo = [];
                     this.historyList.forEach((history) => {
                    if (history.bookingNo && Array.isArray(history.bookingNo)) { 
                        history.bookingNo.forEach((bn) => {
                        if (bn != null && !this.bookingNo.includes(bn)) {
                            this.bookingNo.push(bn);
                        }
                        });
                        }
                        });
                },
                () => this.uploadHistroyloading = false
            );
    }

    getHistoryUI(item: any) {
        return Object.values(this.historyUIMap).find((x: any) => x.match(item));
    }

    closePopup() {
        this.activeModal.dismiss();
    }
}
